import { VimeoPlayer } from '@openeducation/oe-rn-components';
import React, { useEffect, useRef } from 'react';
import { ScrollView, View } from 'react-native';

import styles from './vocabulary-video.style';
import { VIDEO_RATIO_16_9 } from '../../../enums/template-type';
import { useActivityContext } from '../../../hooks/use-activity.context';
import trueBeginnerStr from '../../../utils/true-beginner-str';
import { ContinueButton } from '../../continue-button/continue-button';
import { Instruction } from '../../instruction/instruction.component';
import { ThemedView } from '../../themed-view';

export function VocabularyVideo() {
  const {
    currentActivity,
    isCurrentActivityComplete: isComplete,
    goNextActivity: goNext,
    completeCurrentActivity,
  } = useActivityContext();
  const scrollRef = useRef<ScrollView>(null);

  useEffect(() => completeCurrentActivity(), [completeCurrentActivity]);

  return (
    <>
      <ScrollView ref={scrollRef} contentContainerStyle={styles.container}>
        <View style={styles.content}>
          <Instruction
            text={trueBeginnerStr(
              currentActivity,
              'instructions',
              currentActivity.trueBeginner
            )}
          />

          <VimeoPlayer src={currentActivity.url} ratio={VIDEO_RATIO_16_9} />
          <ThemedView style={[styles.view]} />
        </View>
      </ScrollView>
      {isComplete && <ContinueButton onPress={goNext} />}
    </>
  );
}
